import { atom } from 'jotai';

export const showMarketMapsAtom = atom(false);
